var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYangtai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 47",
    x1: 8.5625,
    y1: 2,
    x2: 8.5625,
    y2: 9.84375,
    stroke: "#0D84A9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34631323",
    d: "M1.75 8V14.75H15.25V8",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 44",
    x1: 1.8125,
    y1: 10.125,
    x2: 15.1875,
    y2: 10.125,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34631324",
    d: "M12.5 14.75V1.75H4.5V14.75",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 45",
    x1: 7.21875,
    y1: 10,
    x2: 7.21875,
    y2: 14.75,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 46",
    x1: 9.84375,
    y1: 10,
    x2: 9.84375,
    y2: 14.75,
    stroke: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYangtai);
export default __webpack_public_path__ + "static/media/yangtai.8aa6cb39a8499118e2d2ccdf5498204a.svg";
export { ForwardRef as ReactComponent };